"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _fluxActions = require("flux-actions");

var _actions = require("./actions");

var _Theme = _interopRequireDefault(require("./Theme"));

var initialState = (0, _immutable.Map)();

var _default = (0, _fluxActions.handleActions)((0, _defineProperty2.default)({}, _actions.FetchThemesActionTypes.SUCCESS, function (state, action) {
  return state.withMutations(function (map) {
    action.payload.data.objects.reduce(function (acc, item) {
      return acc.set(item.id, new _Theme.default(item));
    }, map);
  });
}), initialState);

exports.default = _default;
module.exports = exports.default;